import {
  getSession,
  getUserId,
  getUserLanguage,
  getTempLanguage,
} from "./sessionManagement";

const LEGACY_LANGUAGE_MAP = {
  'en-UK': 'en-GB',
} as const;

const normalizeLanguage = (lang: string | null): string => {
  if (!lang) return 'en-GB';
  return LEGACY_LANGUAGE_MAP[lang as keyof typeof LEGACY_LANGUAGE_MAP] || lang;
};

export const getExchangeHeaders = () => {
  const sessionId = getSession();

  const getLanguageFromStorage = (): string => {
    const userId = getUserId();

    if (userId) {
      const userLanguage = getUserLanguage(userId);
      if (userLanguage) {
        return normalizeLanguage(userLanguage);
      }
    }

    const tempLang = getTempLanguage();
    if (tempLang) {
      return normalizeLanguage(tempLang);
    }

    const fallbackLang = 
      localStorage.getItem("i18nextLng") ||
      sessionStorage.getItem("i18nextLng") ||
      navigator.language ||
      "en-GB";
    
    return normalizeLanguage(fallbackLang);
  };

  const lang = getLanguageFromStorage();

  return {
    "Content-Type": "application/json",
    session_id: sessionId,
    "Accept-Language": `${lang},${lang.slice(0, 2)};q=0.8`,
  };
};
